import React from 'react';
import {useTranslation} from 'react-i18next';
import Datepicker from 'react-tailwindcss-datepicker';
import SelectComponent from '../../../Selects/SelectComponent';

// import { Container } from './styles';

function FiltrosParqueEquipamentos({info}) {
    const {
        filtroNumEquipamento,
        setFiltroNumEquipamento,
        filtroNumSerie,
        setFiltroNumSerie,
        filtroArtigo,
        setFiltroArtigo,
        filtroMarca,
        setFiltroMarca,
        filtroNacionalInternacional,
        setFiltroNacionalInternacional,
        filtroTipo,
        setFiltroTipo,
        filtroModelo,
        setFiltroModelo,
        filtroVersao,
        setFiltroVersao,
        filtroEspecificacao,
        marcas,
        setMarcas,
        nacionaisInternacionais,
        setNacionaisInternacionais,
        tipos,
        setTipos,
        modelos,
        setModelos,
        versoes,
        setVersoes,
        setFiltroEspecificacao,
        filtroDescParque,
        setFiltroDescParque,
    } = info;

    const {t} = useTranslation();
    return (
        <div>
            <div>
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('numeroEquipamento')}
                </label>
                <div className="relative">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>
                    <input
                        type="search"
                        id="default-search"
                        value={filtroNumEquipamento}
                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder={t('filtro')}
                        onChange={e => {
                            setFiltroNumEquipamento(e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className=" mt-2">
                <label htmlFor="first_name" className="block  text-sm font-medium text-gray-900 dark:text-white">
                    {t('descricaoEquip')}
                </label>
                <div className="relative mt-2">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>
                    <input
                        type="search"
                        id="default-search"
                        value={filtroDescParque}
                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder={t('filtro')}
                        onChange={e => {
                            setFiltroDescParque(e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className=" mt-2">
                <label htmlFor="first_name" className="block text-sm font-medium text-gray-900 dark:text-white">
                    {t('numSerie')}
                </label>
                <div className="relative mt-2">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>
                    <input
                        type="search"
                        id="default-search"
                        value={filtroNumSerie}
                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder={t('filtro')}
                        onChange={e => {
                            setFiltroNumSerie(e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className=" mt-2">
                <label htmlFor="first_name" className="block  text-sm font-medium text-gray-900 dark:text-white">
                    {t('artigo')}
                </label>
                <div className="relative mt-2">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>
                    <input
                        type="search"
                        id="default-search"
                        value={filtroArtigo}
                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder={t('filtro')}
                        onChange={e => {
                            setFiltroArtigo(e.target.value);
                        }}
                    />
                </div>
            </div>

            <div className=" mt-4">
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('marca')}
                </label>
                <SelectComponent
                    options={marcas}
                    value={filtroMarca}
                    onChange={e => {
                        setFiltroMarca(e);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('filtro')}
                />
            </div>
            <div className=" mt-4">
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('nacionalInternacional')}
                </label>
                <SelectComponent
                    options={nacionaisInternacionais.filter(o => o.dep === filtroMarca?.value)}
                    value={filtroNacionalInternacional}
                    onChange={e => {
                        setFiltroNacionalInternacional(e);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('filtro')}
                />
            </div>
            <div className=" mt-4">
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('tipo')}
                </label>
                <SelectComponent
                    options={tipos.filter(o => o.dep === filtroNacionalInternacional?.value)}
                    value={filtroTipo}
                    onChange={e => {
                        setFiltroTipo(e);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('filtro')}
                />
            </div>
            <div className=" mt-4">
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('modelo')}
                </label>
                <SelectComponent
                    options={modelos.filter(o => o.dep === filtroTipo?.value)}
                    value={filtroModelo}
                    onChange={e => {
                        setFiltroModelo(e);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('filtro')}
                />
            </div>

            <div className=" mt-2">
                <label htmlFor="first_name" className="block  text-sm font-medium text-gray-900 dark:text-white">
                    {t('versao')}
                </label>
                <SelectComponent
                    options={versoes.filter(o => o.dep === filtroModelo?.value)}
                    value={filtroVersao}
                    onChange={e => {
                        setFiltroVersao(e);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('filtro')}
                />
            </div>
        </div>
    );
}

export default FiltrosParqueEquipamentos;
